module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('document-container', {
    attrs: {
      "header": _vm.header,
      "logo": _vm.logo,
      "tables": _vm.tables,
      "timeout": 12000,
      "documentType": "equivalence-check"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [(_vm.mainLabel) ? _c('h2', {
    staticClass: "product-table-title"
  }, [_vm._v(_vm._s(_vm.mainLabel))]) : _vm._e(), _vm._v(" "), (_vm.listTitle) ? _c('p', [_c('strong', [_vm._v("Vergleichsliste:")]), _vm._v(" " + _vm._s(_vm.listTitle))]) : _vm._e(), _vm._v(" "), (!_vm.skipMessage) ? [(_vm.count === 1) ? _c('p', [_vm._v("Es wurde "), _c('strong', [_vm._v("1 äquivalentes Produkt")]), _vm._v(" gefunden.")]) : _vm._e(), _vm._v(" "), (_vm.count > 1) ? _c('p', [_vm._v("Es wurden "), _c('strong', [_vm._v(_vm._s(_vm.count) + " äquivalente Produkte")]), _vm._v(" gefunden.")]) : _vm._e(), _vm._v(" "), (_vm.count === 0) ? _c('p', [_vm._v("Es wurden "), _c('strong', [_vm._v("keine äquivalenten Produkte")]), _vm._v(" gefunden.")]) : _vm._e()] : [_c('p', [_vm._v(_vm._s(_vm.skipMessage))])], _vm._v(" "), (_vm.count === 0) ? _c('p', [_vm._v(_vm._s(_vm.moment().format('[Stand:] DD. MMMM YYYY, HH:mm [Uhr]')))]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }), _vm._v(" "), (_vm.comment) ? _c('p', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v(_vm._s(_vm.comment))]) : _vm._e()], 2)]), _vm._v(" "), (_vm.tables) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [(_vm.products.length > 0) ? _c('product-table', {
    attrs: {
      "id": 'product-table',
      "table": _vm.tables.findTable('product-table')
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc2a33ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/equivalence-check/ProductEquivalenceCheck.vue
// module id = 721
// module chunks = 0